module.exports = __webpack_public_path__ + "assets/img/sbac_hdr_watchvideobtn.webp?79fa9389f52c69694d95b13c97b8133b";